<template>
  <div class="flags">
    <div class="image-wrapper">
    </div>
    <div class="main-content">
      <img src="@/images/investment/shapes.png" class="image-title" />
      <ul>
        <li>
          When searching <strong>"used cars+country"</strong> OOYYO ALREADY ranks number 1 in many European countries.
        </li>
        <li>
          <strong>OOYYO is ranked #1 in 15 countries</strong> including France,
          Spain, Russia and Turkey
        </li>
        <li>
          OOYYO ranks within top
          <strong>5 positions in Google Search</strong> results for a term:
          “used cars“ in 25+ countries
        </li>
        <li>
          <strong>Currently, present in 27 markets</strong> and generating 10
          million active monthly unique visitors over last 12 months.
        </li>
      </ul>
      <button class="invest-button" @click="onModalOpen('investor')">Apply for investment</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onModalOpen: {
      type: Function,
      default: () => {}
    }
  }
}
</script>
